import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/feedback/face-bad.png'
import _imports_1 from '@/assets/img/feedback/face-normal.png'
import _imports_2 from '@/assets/img/feedback/face-good.png'


const _hoisted_1 = {
  key: 0,
  class: "feedback-modal"
}
const _hoisted_2 = { class: "feedback-modal--window" }
const _hoisted_3 = { class: "feedback-modal--title" }
const _hoisted_4 = { class: "h3 color-secondary" }
const _hoisted_5 = { class: "feedback-modal--wrapper" }
const _hoisted_6 = { class: "feedback-modal--questions" }
const _hoisted_7 = { class: "feedback-modal--questions-title" }
const _hoisted_8 = { class: "h4 color-secondary" }
const _hoisted_9 = { class: "feedback-modal--questions-subtitle" }
const _hoisted_10 = { class: "caption-medium" }
const _hoisted_11 = { class: "feedback-modal--questions-answers" }
const _hoisted_12 = { class: "feedback-modal--questions-answers-item" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "caption-medium" }
const _hoisted_15 = { class: "feedback-modal--questions-answers-item" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "caption-medium" }
const _hoisted_18 = { class: "feedback-modal--questions-answers-item" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "caption-medium" }
const _hoisted_21 = { class: "feedback-modal--comment" }
const _hoisted_22 = { class: "feedback-modal--comment-wrapper" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = { class: "feedback-modal--comment-counter" }
const _hoisted_25 = { class: "feedback-modal--btn" }

import { ref, computed } from "vue";
import BaseButton from "@/components/base/BaseButton.vue";
import { sendFeedback } from "@/server/api/send-feedback.post";
import type { FeedbackFormType } from "@/struct/FeedbackStruct";
import { useStore } from "vuex";
import BaseIcon from "@/components/base/BaseIcon.vue";
import { useI18n } from "vue-i18n";

type AnswerType = 1 | 2 | 3 | null;

interface Question {
  title: string;
  subtitle: string;
  answer: AnswerType;
}

const MAX_LENGTH = 260;


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseFeedback',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "submit-result"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

//store logics
const store = useStore();
const { t } = useI18n();

const currentUserPhone = computed<number>(
  () => store.getters["tariff/currentUserPhone"]
);

const closeModal = () => {
  emit("update:modelValue", false);
};

//answers logics
const questions = ref<Question[]>([
  {
    title: t("base.feedback.questions.tariffTitle"),
    subtitle: t("base.feedback.questions.tariffSubtitle"),
    answer: null,
  },
  {
    title: t("base.feedback.questions.siteTitle"),
    subtitle: t("base.feedback.questions.siteSubtitle"),
    answer: null,
  },
  {
    title: t("base.feedback.questions.supportTitle"),
    subtitle: t("base.feedback.questions.supportSubtitle"),
    answer: null,
  },
]);

const pickAnswer = (answer: Exclude<AnswerType, null>, index: number) => {
  questions.value[index].answer = answer;
};

const isFormValid = computed(() => {
  const allAnswered = questions.value.every((q) => q.answer !== null);
  return allAnswered && comment.value.trim().length > 0;
});

//text area logics
const comment = ref("");
const symbolsCount = computed(() => comment.value.length);

const submit = async () => {
  if (!isFormValid.value) return;

  const data: FeedbackFormType = {
    msisdn: currentUserPhone.value,
    rate_tariff: questions.value[0].answer as number,
    rate_service: questions.value[1].answer as number,
    rate_website: questions.value[2].answer as number,
    comment: comment.value.trim(),
  };
  try {
    const res = await sendFeedback(data);
    console.log(res);
    emit("submit-result", true);
  } catch (err) {
    console.log(err);
    emit("submit-result", false);
  } finally {
    closeModal();
  }
};

return (_ctx: any,_cache: any) => {
  return (_ctx.modelValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "feedback-modal--close color-secondary",
            onClick: closeModal
          }, [
            _createVNode(BaseIcon, { name: "close" })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("base.feedback.title")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "feedback-modal--questions-item"
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(item.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", _hoisted_10, _toDisplayString(item.subtitle), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["feedback-modal--questions-answers-item_pic", { active: item.answer === 1 }]),
                        onClick: ($event: any) => (pickAnswer(1, index))
                      }, _cache[1] || (_cache[1] = [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "face"
                        }, null, -1)
                      ]), 10, _hoisted_13),
                      _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(t)("base.feedback.answers.bad")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["feedback-modal--questions-answers-item_pic", { active: item.answer === 2 }]),
                        onClick: ($event: any) => (pickAnswer(2, index))
                      }, _cache[2] || (_cache[2] = [
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: "face"
                        }, null, -1)
                      ]), 10, _hoisted_16),
                      _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(t)("base.feedback.answers.normal")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["feedback-modal--questions-answers-item_pic", { active: item.answer === 3 }]),
                        onClick: ($event: any) => (pickAnswer(3, index))
                      }, _cache[3] || (_cache[3] = [
                        _createElementVNode("img", {
                          src: _imports_2,
                          alt: "face"
                        }, null, -1)
                      ]), 10, _hoisted_19),
                      _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(t)("base.feedback.answers.good")), 1)
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((comment).value = $event)),
                  maxlength: MAX_LENGTH,
                  placeholder: _unref(t)('base.feedback.placeholder'),
                  class: "feedback-modal--comment-textarea"
                }, null, 8, _hoisted_23), [
                  [_vModelText, comment.value]
                ]),
                _createElementVNode("div", _hoisted_24, _toDisplayString(symbolsCount.value) + " / " + _toDisplayString(MAX_LENGTH), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(BaseButton, {
              title: _unref(t)('base.feedback.submit'),
              disabled: !isFormValid.value,
              onClick: submit
            }, null, 8, ["title", "disabled"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})